export const environment = {
  production: false,
  name: 'staging',

  apiUrl: '',
  socketUrl: '',
  tenantId: 'aubertduval-9zr0q',

  features: {
    'module.free-mode': true,
    'input.attachments': false,
    'free-chat.hide-header-delete': true,
    'free-chat.hide-action-buttons': true,
    'free-chat.show-welcome': true,
    'free-chat.title-from-first-message': true,
    'free-chat.response-feedback': false,
    'module.aed.knowledge-admin': true,
    'bot-response.avatar': 'yoshu_v2'
  }
}
